import { render, staticRenderFns } from "./Delitos.vue?vue&type=template&id=4c736afe"
import script from "./Delitos.vue?vue&type=script&lang=js"
export * from "./Delitos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports